import { render, staticRenderFns } from "./rankinglist.vue?vue&type=template&id=70540b11&"
import script from "./rankinglist.vue?vue&type=script&lang=js&"
export * from "./rankinglist.vue?vue&type=script&lang=js&"
import style0 from "./rankinglist.vue?vue&type=style&index=0&id=70540b11&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports